
const playerPicureMap: { [key: string]: string } = {
    "aksel" : "aksel.png",
    "amanda" : "amanda.png",
    "grøtting" : "grotting.png",
    "henrik" : "henrik.png",
    "martin" : "martink.png",
    "odin" : "odin.png",
    "sander" : "sander.png",
    "sivert" : "sivert.png",
    "thomas" : "thomas.png",
    "trygve" : "trygve.png",
    "kristian" : "kristian.png",
    "bendik" : "bendik.png",
    "fredrik" : "fredrik.png",
    "ola" : "ola.png",
 }


export const ProfilePictureLoader = (playername: string) => {
    const pp = playerPicureMap[playername.toLowerCase()];
    if(!pp) return null;
    const context = require(`./${pp}`);
    return context;
}